// extracted by mini-css-extract-plugin
export default {"root":"Tvbyge","fixNavigationDotsPosition":"s2haxW"};